import React from 'react'
import './Navbar.css'
export default () => {
  return (
    <div className="navbar">
    <header className="nav-header">React + Firebase Authentication</header>
    </div>
    )
}
